export enum PaginationEnum {
	PageIndexIntial = 1,
	PageSize5 = 5,
	PageSize10 = 10,
	PageSize15 = 15,
	PageSize20 = 20,
	PageSize30 = 30,
}
